module.exports = __webpack_public_path__ + "img/syper_324px.001d92c3.png";